import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import { makeStyles, withStyles } from '@material-ui/core/styles'
import {
    Button,
    Grid,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Chip,
    Checkbox,
    FormControlLabel,
} from '@material-ui/core'
import { organizationActions, usergroupActions } from '../../../_state/actions'
import CourseGroupCard from '../../../Components/CourseGroupCard/CourseGroupCard'
import DayOfTheWeekPieChart from '../../../Components/Graphs/DayOfTheWeekPieChart'
import HourOfDayGraph from '../../../Components/Graphs/HourOfDayGraph'
import OrganizationOverviewSidebar from './Components/OrganizationOverviewSidebar'
import DailyUsageGraph, { DailyUsageYLabelType } from '../../../Components/Graphs/DailyUsageGraph'
import { FormattedMessage, useIntl } from 'react-intl'
import DailySessionGraph from '../../../Components/Graphs/DailySessionsGraph'
import moment from 'moment'
import CircularProgress from '@material-ui/core/CircularProgress'
import { CapeeshColors } from '../../../assets/ColorPalette'
import { i18nMessages } from '../../../Logic/CodeAccessible.i18n.Messages'
import { UserStatisticsVisibility } from '../CapeeshConstants'
import { history } from '../../../_state/helpers'
import CourseStatisticsTabBar, { CourseStatisticsTab } from '../../../Components/CourseStatistics/CourseStatisticsTabBar'

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '300px',
        marginLeft: 'calc(15% + 25px)',
        marginRight: '25px',
    },
    button: {
        margin: theme.spacing(1),
    },
    graph: {
        marginTop: 20,
    },
    leaderBoardIndex: {
        background: theme.palette.primary.main,
    },
    reportingSection: {
        marginTop: '10px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
}))

const OrganizationStatistics = (props) => {
    const intl = useIntl()

    const [dayOfWeekUsageStats, setDayOfWeekUsageStats] = useState(null)
    const [hourOfDayUsageStats, setHourOfDayUsageStats] = useState(null)
    const [hourOfDayUsageStatsIndex, setHourOfDayUsageStatsIndex] = useState(null)
    const [showHourOfDayUsageStats, setShowHourOfDayUsageStats] = useState(false)

    const [dailyUsageAggregated, setDailyUsageAggregated] = useState([])
    const [showDailyUsageAggregated, setShowDailyUsageAggregated] = useState(false)

    const [dailyUsage, setDailyUsage] = useState([])
    const [showDailyUsage, setShowDailyUsage] = useState(false)

    const [aggregatedSessions, setAggregatedSessions] = useState([])
    const [showAggregatedSessions, setShowAggregatedSessions] = useState(false)

    const [sessions, setSessions] = useState([])
    const [showSessions, setShowSessions] = useState(false)

    // lesson graph data
    const [graphDataNumberOfLessonsPlayed, setGraphDataNumberOfLessonsPlayed] = useState([])
    const [graphAggregatedNumberOfLessonsPlayed, setGraphAggregatedNumberOfLessonsPlayed] = useState([])
    const [graphDataNumberOfUniqueLessonsPlayed, setGraphDataNumberOfUniqueLessonsPlayed] = useState([])
    const [graphDataAggregatedNumberOfUniqueLessonsPlayed, setGraphDataAggregatedNumberOfUniqueLessonsPlayed] =
        useState([])
    const [graphDataNumberOfCompletedLessons, setGraphDataNumberOfCompletedLessons] = useState([])
    const [graphDataAggregatedNumberOfCompletedLessons, setGraphDataAggregatedNumberOfCompletedLessons] = useState([])
    const [graphDataNumberOfFailedLessons, setGraphDataNumberOfFailedLessons] = useState([])
    const [graphDataAggregatedNumberOfFailedLessons, setGraphDataAggregatedNumberOfFailedLessons] = useState([])
    const [graphDataNumberOfCorrectAnswersInLessons, setGraphDataNumberOfCorrectAnswersInLessons] = useState([])
    const [graphDataAggregatedNumberOfCorrectAnswersInLessons, setGraphDataAggregatedNumberOfCorrectAnswersInLessons] =
        useState([])
    const [graphDataNumberOfIncorrectAnswersInLessons, setGraphDataNumberOfIncorrectAnswersInLessons] = useState([])
    const [
        graphDataAggregatedNumberOfIncorrectAnswersInLessons,
        setGraphDataAggregatedNumberOfIncorrectAnswersInLessons,
    ] = useState([])
    const [graphDataNumberOfStars, setGraphDataNumberOfStars] = useState([])
    const [graphDataAggregatedNumberOfStars, setGraphDataAggregatedNumberOfStars] = useState([])
    const [showLessonRelatedGraphs, setShowLessonRelatedGraphs] = useState(false)

    const [courseGroupModalOpen, setCourseGroupModalOpen] = useState(false)
    const [selectedCourseGroupIds, setSelectedCourseGroupIds] = useState([])
    const [exportFromDate, setExportFromDate] = useState('')
    const [exportToDate, setExportToDate] = useState('')
    const [selectedDatePreset, setSelectedDatePreset] = useState('all')

    // Classrooms start included, admins untick the ones they want left out of the report
    const [excludedUserGroupIds, setExcludedUserGroupIds] = useState([])
    const [includePassedColumn, setIncludePassedColumn] = useState(true)
    const [includeClassroomColumn, setIncludeClassroomColumn] = useState(false)

    const classes = useStyles()

    const currentOrganizationDto = props.organization.myOrganizations?.find(
        (x) => x.id === props.organization.selectedOrganization
    )
    const isStrictMode = currentOrganizationDto?.userStatisticsVisibility === UserStatisticsVisibility.Strict

    useEffect(() => {
        props.dispatch(organizationActions.getGraphDataDayOfWeekOrganization(props.organization.selectedOrganization))
        props.dispatch(
            organizationActions.getGraphDataDailyUsageAggregatedOrganization(props.organization.selectedOrganization)
        )

        props.dispatch(
            organizationActions.getGraphDataDailyLessonAggregatedOrganization(props.organization.selectedOrganization)
        )
        props.dispatch(organizationActions.getGraphDataHourlyOrganization(props.organization.selectedOrganization))
    }, [])

    const updateDayOfWeekGraphData = () => {
        if (
            props.organization.graphDataDayOfWeekOrganization &&
            props.organization.graphDataDayOfWeekOrganization.canShowGraphData
        ) {
            let tempDayOfWeekUsageStats = props.organization.graphDataDayOfWeekOrganization.graphStatsDayOfWeekDtos.map(
                (pie) => ({ name: pie.dayOfWeekShort, value: pie.secondsCombined })
            )
            setDayOfWeekUsageStats(tempDayOfWeekUsageStats)
        }
    }

    useEffect(() => {
        updateAggregateGraphData()
        updateDayOfWeekGraphData()
        updateTimeOfDayGraphData()
        updateLessonPerformenceDataGraphs()
    }, [props.organization])

    const updateAggregateGraphData = () => {
        let tempDailyUsageAggregated = []
        let tempShowDailyUsageAggregated = false

        let tempDailyUsage = []
        let tempShowDailyUsage = false

        let tempAggregatedSessions = []
        let tempShowAggregatedSessions = false

        let tempSessions = []
        let tempShowSessions = false

        if (
            props.organization.graphDataDailyUsageAggregatedOrg &&
            props.organization.graphDataDailyUsageAggregatedOrg.organizationId ===
                props.organization.selectedOrganization &&
            props.organization.graphDataDailyUsageAggregatedOrg.canShowGraphData
        ) {
            tempDailyUsageAggregated = props.organization.graphDataDailyUsageAggregatedOrg.graphStatsAggregateDays.map(
                (x) => ({ name: x.day, value: Math.ceil(x.aggregatedMinutes / 60) })
            )
            tempShowDailyUsageAggregated = true

            tempDailyUsage = props.organization.graphDataDailyUsageAggregatedOrg.graphStatsAggregateDays.map((x) => ({
                name: x.day,
                value: Math.ceil(x.minutes / 60),
            }))
            tempShowDailyUsage = true

            tempAggregatedSessions = props.organization.graphDataDailyUsageAggregatedOrg.graphStatsAggregateDays.map(
                (x) => ({ name: x.day, value: x.aggregatedNumberOfSessions })
            )
            tempShowAggregatedSessions = true

            tempSessions = props.organization.graphDataDailyUsageAggregatedOrg.graphStatsAggregateDays.map((x) => ({
                name: x.day,
                value: x.numberOfSessions,
            }))
            tempShowSessions = true
        }

        setDailyUsageAggregated(tempDailyUsageAggregated)
        setShowDailyUsageAggregated(tempShowDailyUsageAggregated)

        setDailyUsage(tempDailyUsage)
        setShowDailyUsage(tempShowDailyUsage)

        setAggregatedSessions(tempAggregatedSessions)
        setShowAggregatedSessions(tempShowAggregatedSessions)

        setSessions(tempSessions)
        setShowSessions(tempShowSessions)
    }

    const getOrgExcelReportFromTemplate = () => {
        const currentOrganization = props.organization.myOrganizations.find(
            (x) => x.id === props.organization.selectedOrganization
        )

        let date = moment(moment.now()).format('YYYY-MM-DD')
        let filename = 'Organization Report for ' + currentOrganization.name + ' ' + date + '.xlsx'
        props.dispatch(organizationActions.exportExcelFromTemplateOrganizationStats(currentOrganization.id, filename))
    }

    const openCourseGroupModal = () => {
        props.dispatch(organizationActions.getOrganizationCourseGroups(props.organization.selectedOrganization))
        props.dispatch(usergroupActions.getAllUserGroupsForOrganisation(props.organization.selectedOrganization))
        setSelectedCourseGroupIds([])
        setExportFromDate('')
        setExportToDate('')
        setSelectedDatePreset('all')
        setExcludedUserGroupIds([])
        setIncludePassedColumn(true)
        setIncludeClassroomColumn(false)
        setCourseGroupModalOpen(true)
    }

    const closeCourseGroupModal = () => {
        setCourseGroupModalOpen(false)
    }

    const handleDatePreset = (preset) => {
        const now = moment()
        let from = ''
        let to = now.format('YYYY-MM-DD')
        if (preset === 'all') {
            from = ''
            to = ''
        } else if (preset === '7d') {
            from = now.clone().subtract(7, 'days').format('YYYY-MM-DD')
        } else if (preset === '30d') {
            from = now.clone().subtract(30, 'days').format('YYYY-MM-DD')
        } else if (preset === '90d') {
            from = now.clone().subtract(90, 'days').format('YYYY-MM-DD')
        } else if (preset === 'year') {
            from = now.clone().startOf('year').format('YYYY-MM-DD')
        }
        setExportFromDate(from)
        setExportToDate(to)
        setSelectedDatePreset(preset)
    }

    const handleToggleCourseGroup = (courseGroupId) => {
        setSelectedCourseGroupIds((prev) =>
            prev.includes(courseGroupId) ? prev.filter((id) => id !== courseGroupId) : [...prev, courseGroupId]
        )
    }

    const handleToggleSelectAll = () => {
        const allIds = props.organization.organizationCourseGroups?.map((cg) => cg.id) || []
        if (selectedCourseGroupIds.length === allIds.length) {
            setSelectedCourseGroupIds([])
        } else {
            setSelectedCourseGroupIds(allIds)
        }
    }

    const handleExportCourseGroupProgression = () => {
        if (selectedCourseGroupIds.length === 0) return

        const currentOrganization = props.organization.myOrganizations.find(
            (x) => x.id === props.organization.selectedOrganization
        )

        let date = moment(moment.now()).format('YYYY-MM-DD')
        let filename = 'CourseProgression ' + currentOrganization.name + ' ' + date + '.xlsx'

        const fromDate = exportFromDate ? new Date(exportFromDate).toISOString() : undefined
        const toDate = exportToDate ? new Date(exportToDate + 'T23:59:59').toISOString() : undefined

        props.dispatch(
            organizationActions.exportCourseGroupProgressionOrg(
                currentOrganization.id,
                selectedCourseGroupIds,
                filename,
                fromDate,
                toDate,
                props.user.userDashboardLanguageId || 1,
                excludedUserGroupIds,
                {
                    includePassed: includePassedColumn,
                    includeClassroom: includeClassroomColumn,
                }
            )
        )
        setCourseGroupModalOpen(false)
    }

    const toggleExcludedUserGroup = (userGroupId) => {
        setExcludedUserGroupIds((previous) =>
            previous.includes(userGroupId)
                ? previous.filter((x) => x !== userGroupId)
                : [...previous, userGroupId]
        )
    }

    const updateTimeOfDayGraphData = () => {
        let showTimeOfDayStats = false
        let timeOfDayStats = []
        let timeOfDayStatsIndex = {}
        if (
            props.organization.graphDataHourlyOrganization &&
            props.organization.graphDataHourlyOrganization.organizationId === props.organization.selectedOrganization &&
            props.organization.graphDataHourlyOrganization.canShowGraphData
        ) {
            timeOfDayStats = props.organization.graphDataHourlyOrganization.graphStatsHourlyDtos
            timeOfDayStats.forEach((el, index) => (timeOfDayStatsIndex[el.hourOfTheDay] = el.minutesCombined))
            showTimeOfDayStats = true
        }

        setHourOfDayUsageStats(timeOfDayStats)
        setHourOfDayUsageStatsIndex(timeOfDayStatsIndex)
        setShowHourOfDayUsageStats(showTimeOfDayStats)
    }

    const updateLessonPerformenceDataGraphs = () => {
        let tempShowLessonRelatedGraphs = false

        let tempGraphDataNumberOfLessonsPlayed = []
        let tempGraphAggregatedNumberOfLessonsPlayed = []
        let tempGraphDataNumberOfUniqueLessonsPlayed = []
        let tempGraphDataAggregatedNumberOfUniqueLessonsPlayed = []
        let tempGraphDataNumberOfCompletedLessons = []
        let tempGraphDataAggregatedNumberOfCompletedLessons = []
        let tempGraphDataNumberOfFailedLessons = []
        let tempGraphDataAggregatedNumberOfFailedLessons = []
        let tempGraphDataNumberOfCorrectAnswersInLessons = []
        let tempGraphDataAggregatedNumberOfCorrectAnswersInLessons = []
        let tempGraphDataNumberOfIncorrectAnswersInLessons = []
        let tempGraphDataAggregatedNumberOfIncorrectAnswersInLessons = []
        let tempGraphDataNumberOfStars = []
        let tempGraphDataAggregatedNumberOfStars = []

        if (
            props.organization.graphDataDailyLessonAggregatedOrg &&
            props.organization.graphDataDailyLessonAggregatedOrg.organizationId ===
                props.organization.selectedOrganization &&
            props.organization.graphDataDailyLessonAggregatedOrg.aggregatedLessonDailyItemDtos?.length > 0 &&
            props.organization.graphDataDailyLessonAggregatedOrg.canShowGraphData
        ) {
            tempShowLessonRelatedGraphs = true

            tempGraphDataNumberOfLessonsPlayed =
                props.organization.graphDataDailyLessonAggregatedOrg.aggregatedLessonDailyItemDtos.map((x) => ({
                    name: x.day,
                    value: x.numberOfLessonsPlayed,
                }))

            tempGraphAggregatedNumberOfLessonsPlayed =
                props.organization.graphDataDailyLessonAggregatedOrg.aggregatedLessonDailyItemDtos.map((x) => ({
                    name: x.day,
                    value: x.aggregatedNumberOfLessonsPlayed,
                }))

            tempGraphDataNumberOfUniqueLessonsPlayed =
                props.organization.graphDataDailyLessonAggregatedOrg.aggregatedLessonDailyItemDtos.map((x) => ({
                    name: x.day,
                    value: x.numberOfUniqueLessonsPlayed,
                }))

            tempGraphDataAggregatedNumberOfUniqueLessonsPlayed =
                props.organization.graphDataDailyLessonAggregatedOrg.aggregatedLessonDailyItemDtos.map((x) => ({
                    name: x.day,
                    value: x.aggregatedNumberOfUniqueLessonsPlayed,
                }))

            tempGraphDataNumberOfCompletedLessons =
                props.organization.graphDataDailyLessonAggregatedOrg.aggregatedLessonDailyItemDtos.map((x) => ({
                    name: x.day,
                    value: x.numberOfCompletedLessons,
                }))

            tempGraphDataAggregatedNumberOfCompletedLessons =
                props.organization.graphDataDailyLessonAggregatedOrg.aggregatedLessonDailyItemDtos.map((x) => ({
                    name: x.day,
                    value: x.aggregatedNumberOfCompletedLessons,
                }))

            tempGraphDataNumberOfFailedLessons =
                props.organization.graphDataDailyLessonAggregatedOrg.aggregatedLessonDailyItemDtos.map((x) => ({
                    name: x.day,
                    value: x.numberOfFailedLessons,
                }))

            tempGraphDataAggregatedNumberOfFailedLessons =
                props.organization.graphDataDailyLessonAggregatedOrg.aggregatedLessonDailyItemDtos.map((x) => ({
                    name: x.day,
                    value: x.aggregatedNumberOfFailedLessons,
                }))

            tempGraphDataNumberOfCorrectAnswersInLessons =
                props.organization.graphDataDailyLessonAggregatedOrg.aggregatedLessonDailyItemDtos.map((x) => ({
                    name: x.day,
                    value: x.numberOfCorrectAnswersInLessons,
                }))

            tempGraphDataAggregatedNumberOfCorrectAnswersInLessons =
                props.organization.graphDataDailyLessonAggregatedOrg.aggregatedLessonDailyItemDtos.map((x) => ({
                    name: x.day,
                    value: x.aggregatedNumberOfCorrectAnswersInLessons,
                }))
            tempGraphDataNumberOfIncorrectAnswersInLessons =
                props.organization.graphDataDailyLessonAggregatedOrg.aggregatedLessonDailyItemDtos.map((x) => ({
                    name: x.day,
                    value: x.numberOfIncorrectAnswersInLessons,
                }))

            tempGraphDataAggregatedNumberOfIncorrectAnswersInLessons =
                props.organization.graphDataDailyLessonAggregatedOrg.aggregatedLessonDailyItemDtos.map((x) => ({
                    name: x.day,
                    value: x.aggregatedNumberOfIncorrectAnswersInLessons,
                }))
            tempGraphDataNumberOfStars =
                props.organization.graphDataDailyLessonAggregatedOrg.aggregatedLessonDailyItemDtos.map((x) => ({
                    name: x.day,
                    value: x.numberOfStars,
                }))

            tempGraphDataAggregatedNumberOfStars =
                props.organization.graphDataDailyLessonAggregatedOrg.aggregatedLessonDailyItemDtos.map((x) => ({
                    name: x.day,
                    value: x.aggregatedNumberOfStars,
                }))
        }

        setShowLessonRelatedGraphs(tempShowLessonRelatedGraphs)

        setGraphDataNumberOfLessonsPlayed(tempGraphDataNumberOfLessonsPlayed)
        setGraphAggregatedNumberOfLessonsPlayed(tempGraphAggregatedNumberOfLessonsPlayed)
        setGraphDataNumberOfUniqueLessonsPlayed(tempGraphDataNumberOfUniqueLessonsPlayed)
        setGraphDataAggregatedNumberOfUniqueLessonsPlayed(tempGraphDataAggregatedNumberOfUniqueLessonsPlayed)
        setGraphDataNumberOfCompletedLessons(tempGraphDataNumberOfCompletedLessons)
        setGraphDataAggregatedNumberOfCompletedLessons(tempGraphDataAggregatedNumberOfCompletedLessons)
        setGraphDataNumberOfFailedLessons(tempGraphDataNumberOfFailedLessons)
        setGraphDataAggregatedNumberOfFailedLessons(tempGraphDataAggregatedNumberOfFailedLessons)
        setGraphDataNumberOfCorrectAnswersInLessons(tempGraphDataNumberOfCorrectAnswersInLessons)
        setGraphDataAggregatedNumberOfCorrectAnswersInLessons(tempGraphDataAggregatedNumberOfCorrectAnswersInLessons)
        setGraphDataNumberOfIncorrectAnswersInLessons(tempGraphDataNumberOfIncorrectAnswersInLessons)
        setGraphDataAggregatedNumberOfIncorrectAnswersInLessons(
            tempGraphDataAggregatedNumberOfIncorrectAnswersInLessons
        )
        setGraphDataNumberOfStars(tempGraphDataNumberOfStars)
        setGraphDataAggregatedNumberOfStars(tempGraphDataAggregatedNumberOfStars)
    }

    return (
        <div className={classes.root}>
            <OrganizationOverviewSidebar path={props.computedMatch?.path} />
            <CourseStatisticsTabBar
                activeTab={CourseStatisticsTab.Overview}
                onChange={(tab) => {
                    if (tab === CourseStatisticsTab.Courses) {
                        history.push('/dashboard/statistics/courses')
                    }
                }}
            />
            <Grid container spacing={5} style={{ marginTop: '25px' }}>
                <Grid item xs={12} sm={12}>
                    <div className={classes.reportingSection}>
                        <Typography
                            variant="h6"
                            style={{
                                marginRight: '20px',
                                float: 'right',
                                justifyContent: 'flex-start',
                                textAlign: 'left',
                                fontSize: '18px',
                                fontStyle: 'normal',
                                fontWeight: 500,
                            }}>
                            <FormattedMessage
                                id="organization.statistics.downloadreportmsg"
                                defaultMessage="Export a excel sheet for all students, containing statistics for all users in all classrooms."
                            />
                        </Typography>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <Button
                                variant={'contained'}
                                color={'primary'}
                                onClick={() => getOrgExcelReportFromTemplate()}
                                style={{ textAlign: 'center', height: '40px', width: '220px' }}>
                                {!props.organization.isExportingOrgExcelReport && (
                                    <FormattedMessage
                                        id="organization.statistics.downloadreport"
                                        defaultMessage="Download report"
                                    />
                                )}
                                {props.organization.isExportingOrgExcelReport && <CircularProgress size={24} />}
                            </Button>
                            {!isStrictMode && (
                                <Button
                                    variant={'contained'}
                                    color={'primary'}
                                    onClick={() => openCourseGroupModal()}
                                    style={{ textAlign: 'center', height: '40px', width: '280px' }}>
                                    <FormattedMessage
                                        id="organization.statistics.downloadcgprogression"
                                        defaultMessage="Course progression"
                                    />
                                </Button>
                            )}
                        </div>
                    </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <DailyUsageGraph
                        defaultHeaderMessage={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.addmoreusers"
                                defaultMessage="Add more users to see graph"
                            />
                        }
                        headerMessage={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.dailyusage.desc"
                                defaultMessage="Shows how much time the users have spent in the app"
                            />
                        }
                        toolTipYLabelType={DailyUsageYLabelType.AggreatedUsageOverTime}
                        graphData={dailyUsageAggregated}
                        canShowChart={showDailyUsageAggregated}
                        showReferenceLine={false}
                        title={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.time.spent.in.app.aggregated.title"
                                defaultMessage="Time spent in app aggregated"
                            />
                        }
                        yLabel={intl.formatMessage(i18nMessages.dashboardGraphsYLabelHours)}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <DayOfTheWeekPieChart dayOfWeekChartData={dayOfWeekUsageStats} canShowChart={dayOfWeekUsageStats} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <HourOfDayGraph
                        graphData={hourOfDayUsageStats}
                        graphDataIndex={hourOfDayUsageStatsIndex}
                        canShowChart={showHourOfDayUsageStats}
                        showYAxisLabel={false}
                    />
                </Grid>

                {/*<Grid item xs={12} sm={6}>*/}
                {/*    <HourOfDayGraph*/}
                {/*        graphData={timeOfDayStats}*/}
                {/*        graphDataIndex={timeOfDayStatsIndex}*/}
                {/*        canShowChart={showTimeOfDayStats}*/}
                {/*        showYAxisLabel={false}*/}
                {/*    />*/}
                {/*</Grid>*/}

                <Grid item xs={12} sm={6}>
                    <DailyUsageGraph
                        defaultHeaderMessage={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.addmoreusers"
                                defaultMessage="Add more users to see graph"
                            />
                        }
                        headerMessage={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.dailyusage.headermessage"
                                defaultMessage="Shows how much time is spent per day"
                            />
                        }
                        toolTipYLabelType={DailyUsageYLabelType.DailyUsage}
                        graphData={dailyUsage}
                        canShowChart={showDailyUsage}
                        showReferenceLine={false}
                        title={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.dailyusage.title"
                                defaultMessage="Daily usage"
                            />
                        }
                        yLabel={intl.formatMessage(i18nMessages.dashboardGraphsYLabelHours)}
                        isMinutes={false}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <DailySessionGraph
                        defaultHeaderMessage={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.addmoreusers"
                                defaultMessage="Add more users to see graph"
                            />
                        }
                        headerMessage={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.dailysesssions.header"
                                defaultMessage="Shows how many sessions users have in the app over time"
                            />
                        }
                        graphData={aggregatedSessions}
                        canShowChart={showAggregatedSessions}
                        showReferenceLine={false}
                        title={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.dailysesssions.title"
                                defaultMessage="Sessions"
                            />
                        }
                        yLabel={intl.formatMessage(i18nMessages.dashboardGraphsYLabelSessions)}
                        isMinutes={false}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <DailySessionGraph
                        defaultHeaderMessage={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.addmoreusers"
                                defaultMessage="Add more users to see graph"
                            />
                        }
                        toolTipPrefix={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.dailysessions"
                                defaultMessage="Daily sessions"
                            />
                        }
                        graphData={sessions}
                        canShowChart={showSessions}
                        showReferenceLine={true}
                        title={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.sessionperday"
                                defaultMessage="Session per day"
                            />
                        }
                        yLabel={intl.formatMessage(i18nMessages.dashboardGraphsYLabelSessions)}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <DailyUsageGraph
                        defaultHeaderMessage={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.addmoreusers"
                                defaultMessage="Add more users to see graph"
                            />
                        }
                        toolTipPrefix={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.numberofstars"
                                defaultMessage="Number of stars"
                            />
                        }
                        graphData={graphDataAggregatedNumberOfStars}
                        canShowChart={showLessonRelatedGraphs}
                        showReferenceLine={true}
                        title={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.numberofstarsaggregated"
                                defaultMessage="Number of stars per day aggregated"
                            />
                        }
                        yLabel={intl.formatMessage(i18nMessages.dashboardGraphsYLabelStars)}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <DailyUsageGraph
                        defaultHeaderMessage={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.addmoreusers"
                                defaultMessage="Add more users to see graph"
                            />
                        }
                        toolTipPrefix={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.numberofstars"
                                defaultMessage="Number of stars"
                            />
                        }
                        graphData={graphDataNumberOfStars}
                        canShowChart={showLessonRelatedGraphs}
                        showReferenceLine={true}
                        title={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.numberofstarsperday"
                                defaultMessage="Number of stars per day"
                            />
                        }
                        yLabel={intl.formatMessage(i18nMessages.dashboardGraphsYLabelStars)}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <DailyUsageGraph
                        defaultHeaderMessage={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.addmoreusers"
                                defaultMessage="Add more users to see graph"
                            />
                        }
                        toolTipPrefix={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.numberoflessons"
                                defaultMessage="Number of lessons"
                            />
                        }
                        graphData={graphDataNumberOfLessonsPlayed}
                        canShowChart={showLessonRelatedGraphs}
                        showReferenceLine={false}
                        title={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.lessonsplayedperday"
                                defaultMessage="Lessons played per day"
                            />
                        }
                        yLabel={intl.formatMessage(i18nMessages.dashboardGraphsYLabelLessons)}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <DailyUsageGraph
                        defaultHeaderMessage={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.addmoreusers"
                                defaultMessage="Add more users to see graph"
                            />
                        }
                        headerMessage={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.dailylessons.header"
                                defaultMessage="Shows lessons have been played over time"
                            />
                        }
                        toolTipYLabelType={DailyUsageYLabelType.NumberOfLessons}
                        graphData={graphAggregatedNumberOfLessonsPlayed}
                        canShowChart={showLessonRelatedGraphs}
                        showReferenceLine={false}
                        title={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.dailylessons.title"
                                defaultMessage="Lessons played"
                            />
                        }
                        yLabel={intl.formatMessage(i18nMessages.dashboardGraphsYLabelLessons)}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <DailyUsageGraph
                        defaultHeaderMessage={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.addmoreusers"
                                defaultMessage="Add more users to see graph"
                            />
                        }
                        toolTipPrefix={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.uniquelessons"
                                defaultMessage="Unique lessons"
                            />
                        }
                        graphData={graphDataNumberOfUniqueLessonsPlayed}
                        canShowChart={showLessonRelatedGraphs}
                        showReferenceLine={false}
                        title={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.uniquelessonsperdy"
                                defaultMessage="Unique lessons per day"
                            />
                        }
                        yLabel={intl.formatMessage(i18nMessages.dashboardGraphsYLabelLessons)}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <DailyUsageGraph
                        defaultHeaderMessage={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.addmoreusers"
                                defaultMessage="Add more users to see graph"
                            />
                        }
                        toolTipPrefix={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.uniquelessons"
                                defaultMessage="Unique lessons"
                            />
                        }
                        graphData={graphDataAggregatedNumberOfUniqueLessonsPlayed}
                        canShowChart={showLessonRelatedGraphs}
                        showReferenceLine={false}
                        title={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.uniquelessonsaggregated"
                                defaultMessage="Unique lessons per day aggregated"
                            />
                        }
                        yLabel={intl.formatMessage(i18nMessages.dashboardGraphsYLabelLessons)}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <DailyUsageGraph
                        defaultHeaderMessage={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.addmoreusers"
                                defaultMessage="Add more users to see graph"
                            />
                        }
                        toolTipPrefix={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.completedlessons"
                                defaultMessage="Completed lessons"
                            />
                        }
                        graphData={graphDataNumberOfCompletedLessons}
                        canShowChart={showLessonRelatedGraphs}
                        showReferenceLine={false}
                        title={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.numberofcompletedlessons"
                                defaultMessage="Number of completed lessons"
                            />
                        }
                        yLabel={intl.formatMessage(i18nMessages.dashboardGraphsYLabelLessons)}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <DailyUsageGraph
                        defaultHeaderMessage={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.addmoreusers"
                                defaultMessage="Add more users to see graph"
                            />
                        }
                        toolTipPrefix={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.completedlessons"
                                defaultMessage="Completed lessons"
                            />
                        }
                        graphData={graphDataAggregatedNumberOfCompletedLessons}
                        canShowChart={showLessonRelatedGraphs}
                        showReferenceLine={false}
                        title={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.numberofcompletedlessonsaggregated"
                                defaultMessage="Number of completed lesson aggregated"
                            />
                        }
                        yLabel={intl.formatMessage(i18nMessages.dashboardGraphsYLabelLessons)}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <DailyUsageGraph
                        defaultHeaderMessage={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.addmoreusers"
                                defaultMessage="Add more users to see graph"
                            />
                        }
                        toolTipPrefix={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.failedlessons"
                                defaultMessage="Failed lessons"
                            />
                        }
                        graphData={graphDataNumberOfFailedLessons}
                        canShowChart={showLessonRelatedGraphs}
                        showReferenceLine={false}
                        title={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.numberoffailedlessons"
                                defaultMessage="Number of failed lesson"
                            />
                        }
                        yLabel={intl.formatMessage(i18nMessages.dashboardGraphsYLabelLessons)}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <DailyUsageGraph
                        defaultHeaderMessage={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.addmoreusers"
                                defaultMessage="Add more users to see graph"
                            />
                        }
                        toolTipPrefix={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.failedlessons"
                                defaultMessage="Failed lessons"
                            />
                        }
                        graphData={graphDataAggregatedNumberOfFailedLessons}
                        canShowChart={showLessonRelatedGraphs}
                        showReferenceLine={false}
                        title={
                            <FormattedMessage
                                id="dashboard.classroom.graphs.numberoffailedlessonsaggregated"
                                defaultMessage="Number of failed lesson aggregated"
                            />
                        }
                        yLabel={intl.formatMessage(i18nMessages.dashboardGraphsYLabelLessons)}
                    />
                </Grid>

                {/*<Grid item xs={12} sm={6}>*/}
                {/*  <DailyUsageGraph*/}
                {/*    defaultHeaderMessage={"Add more users to see graph"}*/}
                {/*    toolTipPrefix={"Answers"}*/}
                {/*    graphData={graphDataNumberOfCorrectAnswersInLessons}*/}
                {/*    canShowChart={showLessonRelatedGraphs}*/}
                {/*    showReferenceLine={false}*/}
                {/*    title={"Number of correct answers"}*/}
                {/*    yLabel={"answers"}*/}
                {/*  />*/}
                {/*</Grid>*/}

                {/*<Grid item xs={12} sm={6}>*/}
                {/*  <DailyUsageGraph*/}
                {/*    defaultHeaderMessage={"Add more users to see graph"}*/}
                {/*    toolTipPrefix={"Answers"}*/}
                {/*    graphData={graphDataAggregatedNumberOfCorrectAnswersInLessons}*/}
                {/*    canShowChart={showLessonRelatedGraphs}*/}
                {/*    showReferenceLine={false}*/}
                {/*    title={"Number of correct answers aggregated"}*/}
                {/*    yLabel={"answers"}*/}
                {/*  />*/}
                {/*</Grid>*/}

                {/*<Grid item xs={12} sm={6}>*/}
                {/*  <DailyUsageGraph*/}
                {/*    defaultHeaderMessage={"Add more users to see graph"}*/}
                {/*    toolTipPrefix={"Answers"}*/}
                {/*    graphData={graphDataNumberOfIncorrectAnswersInLessons}*/}
                {/*    canShowChart={showLessonRelatedGraphs}*/}
                {/*    showReferenceLine={false}*/}
                {/*    title={"Number of incorrect answers"}*/}
                {/*    yLabel={"answers"}*/}
                {/*  />*/}
                {/*</Grid>*/}

                {/*<Grid item xs={12} sm={6}>*/}
                {/*  <DailyUsageGraph*/}
                {/*    defaultHeaderMessage={"Add more users to see graph"}*/}
                {/*    toolTipPrefix={"Answers"}*/}
                {/*    graphData={graphDataAggregatedNumberOfIncorrectAnswersInLessons}*/}
                {/*    canShowChart={showLessonRelatedGraphs}*/}
                {/*    showReferenceLine={false}*/}
                {/*    title={"Number of incorrect answers aggregated"}*/}
                {/*    yLabel={"answers"}*/}
                {/*  />*/}
                {/*</Grid>*/}
            </Grid>

            <Dialog open={courseGroupModalOpen} onClose={closeCourseGroupModal} fullWidth maxWidth="md">
                <DialogTitle>
                    <FormattedMessage
                        id="organization.statistics.selectcoursegroupsforexport"
                        defaultMessage="Select course groups to export"
                    />
                </DialogTitle>
                <DialogContent>
                    <div style={{ marginBottom: '16px' }}>
                        <Typography variant="subtitle2" style={{ marginBottom: '8px' }}>
                            <FormattedMessage id="dashboard.export.daterange" defaultMessage="Date range (optional)" />
                        </Typography>
                        <div style={{ display: 'flex', gap: '8px', marginBottom: '8px', flexWrap: 'wrap' }}>
                            {[
                                { key: 'all', label: 'All time' },
                                { key: '7d', label: 'Last 7 days' },
                                { key: '30d', label: 'Last 30 days' },
                                { key: '90d', label: 'Last 90 days' },
                                { key: 'year', label: 'This year' },
                            ].map((preset) => (
                                <Chip
                                    key={preset.key}
                                    label={preset.label}
                                    clickable
                                    color={selectedDatePreset === preset.key ? 'primary' : 'default'}
                                    variant={selectedDatePreset === preset.key ? 'default' : 'outlined'}
                                    onClick={() => handleDatePreset(preset.key)}
                                />
                            ))}
                        </div>
                        <div style={{ display: 'flex', gap: '12px' }}>
                            <TextField
                                label="From"
                                type="date"
                                value={exportFromDate}
                                onChange={(e) => { setExportFromDate(e.target.value); setSelectedDatePreset('custom') }}
                                InputLabelProps={{ shrink: true }}
                                size="small"
                                style={{ width: '180px' }}
                            />
                            <TextField
                                label="To"
                                type="date"
                                value={exportToDate}
                                onChange={(e) => { setExportToDate(e.target.value); setSelectedDatePreset('custom') }}
                                InputLabelProps={{ shrink: true }}
                                size="small"
                                style={{ width: '180px' }}
                            />
                        </div>
                    </div>
                    {props.organization.fetchingCourseGroups ? (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                            <CircularProgress />
                        </div>
                    ) : (
                        <div>
                            {props.organization.organizationCourseGroups?.length > 0 && (
                                <div style={{ marginBottom: '12px' }}>
                                    <Button variant="outlined" size="small" onClick={handleToggleSelectAll}>
                                        {selectedCourseGroupIds.length === props.organization.organizationCourseGroups.length ? (
                                            <FormattedMessage id="globalwords.deselectall" defaultMessage="Deselect all" />
                                        ) : (
                                            <FormattedMessage id="globalwords.selectall" defaultMessage="Select all" />
                                        )}
                                    </Button>
                                </div>
                            )}
                            {props.organization.organizationCourseGroups?.map((courseGroup, index) => (
                                <div key={courseGroup.id} style={{ marginBottom: '8px' }}>
                                    <CourseGroupCard
                                        courseGroup={courseGroup}
                                        index={index}
                                        handleCheckMarkCourseGroup={handleToggleCourseGroup}
                                        checked={selectedCourseGroupIds.includes(courseGroup.id)}
                                    />
                                </div>
                            ))}
                            {(!props.organization.organizationCourseGroups ||
                                props.organization.organizationCourseGroups.length === 0) && (
                                <Typography variant="body2">
                                    <FormattedMessage
                                        id="organization.statistics.nocoursegroupsavailable"
                                        defaultMessage="No course groups available."
                                    />
                                </Typography>
                            )}
                        </div>
                    )}

                    <div style={{ marginTop: '20px' }}>
                        <Typography variant="subtitle2" style={{ marginBottom: '4px' }}>
                            {intl.formatMessage(i18nMessages.exportClassroomsToInclude)}
                        </Typography>
                        <Typography variant="body2" style={{ marginBottom: '8px', color: CapeeshColors.Gray1 }}>
                            {intl.formatMessage(i18nMessages.exportClassroomsToIncludeDescription)}
                        </Typography>
                        {props.usergroup?.usergroups?.length > 0 ? (
                            <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                {props.usergroup.usergroups.map((userGroup) => (
                                    <div key={userGroup.id}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={!excludedUserGroupIds.includes(userGroup.id)}
                                                    onChange={() => toggleExcludedUserGroup(userGroup.id)}
                                                    color="primary"
                                                    size="small"
                                                />
                                            }
                                            label={userGroup.name}
                                        />
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <Typography variant="body2">
                                {intl.formatMessage(i18nMessages.exportNoClassroomsAvailable)}
                            </Typography>
                        )}
                    </div>

                    <div style={{ marginTop: '20px' }}>
                        <Typography variant="subtitle2" style={{ marginBottom: '4px' }}>
                            {intl.formatMessage(i18nMessages.exportColumns)}
                        </Typography>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={includePassedColumn}
                                    onChange={(event) => setIncludePassedColumn(event.target.checked)}
                                    color="primary"
                                    size="small"
                                />
                            }
                            label={intl.formatMessage(i18nMessages.exportColumnPassed)}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={includeClassroomColumn}
                                    onChange={(event) => setIncludeClassroomColumn(event.target.checked)}
                                    color="primary"
                                    size="small"
                                />
                            }
                            label={intl.formatMessage(i18nMessages.exportColumnClassroom)}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeCourseGroupModal}>
                        <FormattedMessage id="globalwords.cancel" defaultMessage="Cancel" />
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={
                            selectedCourseGroupIds.length === 0 || props.organization.isExportingCourseGroupProgression
                        }
                        onClick={handleExportCourseGroupProgression}>
                        {props.organization.isExportingCourseGroupProgression ? (
                            <CircularProgress size={24} color="inherit" />
                        ) : (
                            <FormattedMessage id="globalwords.download" defaultMessage="Download" />
                        )}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

function mapStateToProps(state) {
    const { organization, user, usergroup } = state
    return {
        organization,
        user,
        usergroup,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationStatistics)
